import { DestroyRef, Directive, ElementRef, inject, Input, OnInit } from '@angular/core';
import { selectCurrency } from '@app/project/store';
import { IRootState } from '@app/store';
import { Store } from '@ngrx/store';
import { IProjectCurrency } from '@shared/model/project';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, shareReplay, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


@Directive({
  selector: '[appProjectCurrency]',
  standalone: true
})
export class ProjectCurrencyDirective implements OnInit {

  @Input() mode: 'full' | 'currency' | 'multiplication' = 'full';
  @Input() addText? = '';

  private projectCurrency$: Observable<IProjectCurrency> = this._store.select(selectCurrency);
  private destroyRef = inject(DestroyRef);

  constructor(
    private _store: Store<IRootState>,
    private el: ElementRef
  ) { }

  ngOnInit(): void {
    this.projectCurrency$
      .pipe(
        distinctUntilChanged(),
        shareReplay(),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(currencyData => {
        const currentText = this.el.nativeElement.innerText;
        let result = currentText;
        let hasCurrencyData = false;
        let parts: string[] = [];

        switch (this.mode) {
          case 'full':
            if (currencyData?.currency) parts.push(currencyData.currency);
            if (currencyData?.currency_multiplication) parts.push(currencyData.currency_multiplication);
            hasCurrencyData = parts.length > 0;
            if (hasCurrencyData) {
              result = `${currentText}, ${parts.join(' ')}${this.addText}`;
            }
            break;

          case 'currency':
            if (currencyData?.currency) {
              result = `${currentText}, ${currencyData.currency}${this.addText}`;
            }
            break;

          case 'multiplication':
            if (currencyData?.currency_multiplication) {
              result = `${currentText}, ${currencyData.currency_multiplication}${this.addText}`;
            }
            break;
        }

        this.el.nativeElement.textContent = result;
      });
  }
}
